var _circle, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1218_126)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7406 48.6396H51.83C47.7145 51.0622 50.1152 52.9973 51.83 53.662L54.6052 53.8097C54.4969 52.2735 56.3651 49.7229 57.3127 48.6396L55.5528 49.1567C55.3904 48.8612 54.9436 48.6889 54.7406 48.6396Z",
    fill: "#393184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1236 34.0895C45.4361 34.6284 42.9749 37.1211 42.3331 40.9671C42.1403 42.1228 42.2008 44.3585 42.4572 45.5545C42.932 47.769 43.8575 49.7114 45.4449 51.825C46.2917 52.9527 46.4948 53.3781 46.4928 54.0193C46.489 55.1493 45.9721 55.6523 44.0266 56.4193C41.413 57.4498 37.8467 59.583 36.5572 60.8874C35.7041 61.7503 35.323 62.4016 35.1283 63.3293C34.652 65.5978 35.497 67.2118 37.7458 68.3289C39.2321 69.0672 41.1847 69.5189 44.4676 69.884C45.8699 70.04 54.7477 70.0388 56.415 69.8825C61.8457 69.3735 64.6861 68.2677 65.6163 66.3006C65.8771 65.7492 65.886 65.6909 65.8842 64.5547C65.882 63.2051 65.7743 62.7408 65.2588 61.8604C64.2914 60.2082 61.6403 58.4501 57.9511 57.014C56.3762 56.4011 55.7426 56.0907 55.2542 55.6933C54.6784 55.2247 54.5476 54.9526 54.5472 54.2227L54.5469 53.5989L53.1349 53.5687C51.5314 53.5343 51.2823 53.4566 50.6981 52.8085C49.6405 51.6355 49.9447 49.8647 51.3351 49.0998L51.8098 48.8386H53.287C54.7426 48.8386 54.7704 48.8422 55.1935 49.0813C55.6543 49.3416 55.6422 49.3416 56.7438 49.0858C57.4085 48.9315 57.4023 48.9388 57.8526 47.7728C58.9393 44.9584 59.1063 41.9716 58.3172 39.4636C57.2243 35.9903 54.3029 33.9554 50.4785 34.0038C50.016 34.0096 49.4063 34.0482 49.1236 34.0895Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1218_126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7737 30.1156C43.1984 31.0589 38.8946 35.5422 38.252 41.0761L38.1494 41.9597L37.7672 42.2955C37.5571 42.4803 37.2984 42.7937 37.1925 42.9921C37.0058 43.3419 37 43.4333 37 46.0084C37 48.4326 37.0142 48.6906 37.162 48.9688C37.5865 49.7676 38.1964 50.1388 39.0854 50.1397C39.7728 50.1404 40.1937 49.978 40.6252 49.5457C41.1888 48.9808 41.2102 48.8522 41.2123 46.0037L41.2142 43.4306L40.9843 42.9682C40.8439 42.686 40.6252 42.4164 40.4228 42.2764C40.2294 42.1424 40.09 41.9741 40.0883 41.8726C40.081 41.4461 40.3746 39.9823 40.6062 39.2893C41.8485 35.5739 44.7997 32.9498 48.7302 32.0662C49.4309 31.9086 52.1134 31.9086 52.8141 32.0662C56.1733 32.8214 58.8254 34.8404 60.2979 37.7633C60.8003 38.7606 61.1594 39.8473 61.3255 40.8737C61.5065 41.9919 61.5035 42.0118 61.1192 42.2779C60.9086 42.4238 60.6997 42.6845 60.5533 42.9844L60.3212 43.4598L60.335 46.1868C60.3509 49.2983 60.4457 48.9451 59.4612 49.4426C58.4992 49.9288 57.3804 50.2634 56.1177 50.4426C55.5303 50.5259 55.5159 50.5232 55.2354 50.2763C54.8843 49.9674 54.4632 49.8956 53.264 49.9401C52.2686 49.977 52.019 50.0779 51.7241 50.5625C51.5149 50.9064 51.5028 51.5104 51.6984 51.8422C51.9854 52.3291 52.3659 52.4516 53.5905 52.4516C54.7703 52.4516 54.9849 52.3949 55.3707 51.981C55.4866 51.8568 55.6672 51.7551 55.7721 51.7551C56.113 51.7551 57.4909 51.4958 58.1144 51.3142C59.0779 51.0337 60.0082 50.639 60.6708 50.2297L61.283 49.8514L61.5669 49.9972C61.99 50.2145 62.9689 50.1915 63.4147 49.9538C63.8202 49.7375 64.1547 49.397 64.3823 48.9688C64.5301 48.6906 64.5443 48.4326 64.5443 46.0084C64.5443 43.4242 64.5391 43.343 64.3496 42.9877C64.2424 42.7869 63.9826 42.4784 63.7723 42.3022C63.3991 41.9896 63.3882 41.9659 63.3289 41.3327C63.1725 39.6585 62.5279 37.7025 61.6406 36.2088C59.6713 32.8938 56.5063 30.7296 52.7298 30.1158C51.7803 29.9614 49.6854 29.9614 48.7737 30.1156Z",
    fill: "url(#paint1_linear_1218_126)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7737 30.1156C43.1984 31.0589 38.8946 35.5422 38.252 41.0761L38.1494 41.9597L37.7672 42.2955C37.5571 42.4803 37.2984 42.7937 37.1925 42.9921C37.0058 43.3419 37 43.4333 37 46.0084C37 48.4326 37.0142 48.6906 37.162 48.9688C37.5865 49.7676 38.1964 50.1388 39.0854 50.1397C39.7728 50.1404 40.1937 49.978 40.6252 49.5457C41.1888 48.9808 41.2102 48.8522 41.2123 46.0037L41.2142 43.4306L40.9843 42.9682C40.8439 42.686 40.6252 42.4164 40.4228 42.2764C40.2294 42.1424 40.09 41.9741 40.0883 41.8726C40.081 41.4461 40.3746 39.9823 40.6062 39.2893C41.8485 35.5739 44.7997 32.9498 48.7302 32.0662C49.4309 31.9086 52.1134 31.9086 52.8141 32.0662C56.1733 32.8214 58.8254 34.8404 60.2979 37.7633C60.8003 38.7606 61.1594 39.8473 61.3255 40.8737C61.5065 41.9919 61.5035 42.0118 61.1192 42.2779C60.9086 42.4238 60.6997 42.6845 60.5533 42.9844L60.3212 43.4598L60.335 46.1868C60.3509 49.2983 60.4457 48.9451 59.4612 49.4426C58.4992 49.9288 57.3804 50.2634 56.1177 50.4426C55.5303 50.5259 55.5159 50.5232 55.2354 50.2763C54.8843 49.9674 54.4632 49.8956 53.264 49.9401C52.2686 49.977 52.019 50.0779 51.7241 50.5625C51.5149 50.9064 51.5028 51.5104 51.6984 51.8422C51.9854 52.3291 52.3659 52.4516 53.5905 52.4516C54.7703 52.4516 54.9849 52.3949 55.3707 51.981C55.4866 51.8568 55.6672 51.7551 55.7721 51.7551C56.113 51.7551 57.4909 51.4958 58.1144 51.3142C59.0779 51.0337 60.0082 50.639 60.6708 50.2297L61.283 49.8514L61.5669 49.9972C61.99 50.2145 62.9689 50.1915 63.4147 49.9538C63.8202 49.7375 64.1547 49.397 64.3823 48.9688C64.5301 48.6906 64.5443 48.4326 64.5443 46.0084C64.5443 43.4242 64.5391 43.343 64.3496 42.9877C64.2424 42.7869 63.9826 42.4784 63.7723 42.3022C63.3991 41.9896 63.3882 41.9659 63.3289 41.3327C63.1725 39.6585 62.5279 37.7025 61.6406 36.2088C59.6713 32.8938 56.5063 30.7296 52.7298 30.1158C51.7803 29.9614 49.6854 29.9614 48.7737 30.1156Z",
    stroke: "url(#paint2_linear_1218_126)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1218_126",
    x: 34.85,
    y: 27.85,
    width: 31.8439,
    height: 26.7512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1218_126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1218_126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1218_126",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1218_126",
    x1: 39.9475,
    y1: 32.0714,
    x2: 66.8094,
    y2: 49.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1218_126",
    x1: 53.0675,
    y1: 33.7419,
    x2: 60.3072,
    y2: 54.4663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP3);
export default __webpack_public_path__ + "static/media/p3.9684bebd900f12e8114ecdcce9952de7.svg";
export { ForwardRef as ReactComponent };